import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiltersForm } from '../components/FiltersForm';
import { SvgLineChart } from '../components/SvgLineChart';
import { Table } from '../components/Table';
import { DownloadMenu } from '../components/DownloadMenu';
import { Section } from '../components/Section';
import { timeseriesSchema } from '../validation';
import { useKpiTimeseries, useQueryParams } from '../hooks/useKpi';
import type { TimeseriesParams } from '../types';

const defaults: TimeseriesParams = { collection: '', interval: 'day', metric: 'sum', field: '' };

export default function TimeSeries() {
  const [search] = useSearchParams();
  const merged = useQueryParams(defaults, search) as any;
  const [params, setParams] = useState<TimeseriesParams | undefined>(merged.collection ? merged : undefined);
  const query = useKpiTimeseries(params);

  return (
    <Section title="Series de tiempo" description="Consulta agregados por intervalo">
      <FiltersForm defaultValues={merged} schema={timeseriesSchema} fields={[{ name: 'collection', label: 'Colección' }, { name: 'interval', label: 'Intervalo', type: 'select', options: ['day', 'week', 'month'] }, { name: 'metric', label: 'Métrica', type: 'select', options: ['sum', 'avg', 'min', 'max'] }, { name: 'field', label: 'Campo' }]} onSubmit={(values) => setParams(values)} />
      {query.isLoading && <p>Cargando...</p>}
      {query.error && <p className="text-red-600">Error al cargar</p>}
      {query.data && <div className="space-y-4"><SvgLineChart data={query.data.map((d) => ({ label: d.date, value: d.value }))} /><DownloadMenu filename="timeseries" rows={query.data as any} /><Table rows={query.data as any} /></div>}
    </Section>
  );
}
